(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    /**
   * Price Range Slider
   *
   * KEY FIX: The hidden inputs are kept in the EXACT same format
   * as the original working text-input code:
   *   - Same `name` attributes (filter.min_value.param_name)
   *   - Same `type="text"` with `inputmode="decimal"`
   *   - Same value format: money_without_currency (e.g. "7000.00")
   *   - Same `data-min` / `data-max` attributes
   *   - Same `class="field__input"`
   *
   * The theme's /updatePriceFilterAndResults handler reads these
   * inputs by ref or name and expects this exact format.
   *
   * Slider works in whole display units (0–11000).
   * On change, JS converts: slider 7000 → hidden input "7000.00"
   * This matches what money_without_currency would output for ₹7,000.
   */
  (function () {
    document.querySelectorAll('price-facet-component').forEach(function (component) {
      var minRange = component.querySelector('[ref="minRange"]');
      var maxRange = component.querySelector('[ref="maxRange"]');
      var trackFill = component.querySelector('[ref="trackFill"]');
      var minLabel = component.querySelector('[ref="minLabel"]');
      var maxLabel = component.querySelector('[ref="maxLabel"]');
      var minInput = component.querySelector('[ref="minInput"]');
      var maxInput = component.querySelector('[ref="maxInput"]');
      var currencySymbol = component.dataset.currencySymbol || '₹';
      var sliderMax = parseFloat(component.dataset.rangeMaxDisplay) || 100;

      if (!minRange || !maxRange) return;

      function formatLabel(num) {
        return Number(num).toLocaleString('en-IN');
      }

      /**
       * Convert slider value to money_without_currency format.
       * Shopify's money_without_currency for INR outputs "7000.00"
       * So slider value 7000 → "7000.00"
       */
      function toMoneyWithoutCurrency(val) {
        return parseFloat(val).toFixed(2);
      }

      function updateVisuals() {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);

        // Fill bar
        var minPct = (minVal / sliderMax) * 100;
        var maxPct = (maxVal / sliderMax) * 100;

        if (trackFill) {
          trackFill.style.left = minPct + '%';
          trackFill.style.right = (100 - maxPct) + '%';
        }

        // Labels
        if (minLabel) {
          minLabel.textContent = currencySymbol + ' ' + formatLabel(minVal);
        }
        if (maxLabel) {
          maxLabel.textContent = currencySymbol + ' ' + formatLabel(maxVal);
        }
      }

      function updateHiddenInputs() {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);

        /**
         * Write values in money_without_currency format.
         * This is the SAME format the original text inputs used.
         *
         * If min is 0 → clear the value (no filter applied)
         * If max equals slider max → clear the value (no filter applied)
         * Otherwise → write "7000.00" format
         */
        if (minInput) {
          if (minVal > 0) {
            minInput.value = toMoneyWithoutCurrency(minVal);
          } else {
            minInput.value = '';
          }
        }

        if (maxInput) {
          if (maxVal < sliderMax) {
            maxInput.value = toMoneyWithoutCurrency(maxVal);
          } else {
            maxInput.value = '';
          }
        }
      }

      /* Live drag — visuals only, no filter trigger */
      minRange.addEventListener('input', function () {
        if (parseFloat(minRange.value) > parseFloat(maxRange.value)) {
          minRange.value = maxRange.value;
        }
        updateVisuals();
      });

      maxRange.addEventListener('input', function () {
        if (parseFloat(maxRange.value) < parseFloat(minRange.value)) {
          maxRange.value = minRange.value;
        }
        updateVisuals();
      });

      /* On release — write hidden inputs THEN trigger theme handler */
      minRange.addEventListener('change', function () {
        if (parseFloat(minRange.value) > parseFloat(maxRange.value)) {
          minRange.value = maxRange.value;
        }
        updateVisuals();
        updateHiddenInputs();
        /* Dispatch change on the component — this triggers
           on:change="/updatePriceFilterAndResults" */
        component.dispatchEvent(new Event('change', { bubbles: true }));
      });

      maxRange.addEventListener('change', function () {
        if (parseFloat(maxRange.value) < parseFloat(minRange.value)) {
          maxRange.value = minRange.value;
        }
        updateVisuals();
        updateHiddenInputs();
        component.dispatchEvent(new Event('change', { bubbles: true }));
      });

      /* Initial render */
      updateVisuals();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
